import { z } from 'zod';

export type ProcessingArtifact = z.infer<typeof processingArtifactSchema>;

export const processingArtifactSchema = z.object({
  name: z.string(),
  path: z.string(),
  required: z.boolean(),
  files: z.array(z.string()).optional(),
});
